import { Menu } from "@mui/icons-material";
import { Avatar, Box, CircularProgress, Drawer, Link, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import React, { useState } from "react";
import toList, { isAuthenticated, loggedUser, logout } from "../utils/ComponentUtil";
import CustomAccordion from "../utils/CustomAccordion";
import Gmail from '../../images/gmail.png';
import profile from '../../images/Ellipse_170.png'
import Email from '../../images/mail.png';
import Logout from '../../images/logout.png';
import CustomButton from '../utils/CustomButton';
import './NavSideBar.scss';
import ProfileAPI from "../Apis/ProfileAPI";

function HamburgerMenu({ options = {} }) {
    const [open, setState] = useState(false);
    const isLoggedIn = isAuthenticated();
    const user = loggedUser();
    const profileCompleted = ProfileAPI.profileCompleted();
    const toggleDrawer = (open) => (event) => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        //changes the function state according to the value of open
        setState(open);
    };
    const toLoginBtn = (img, name, to) => {
        return <div className="login-btn-wrp">
            <Link reloadDocument={true} href={to}>
                <div className="inner-container">
                    <img className="gmail" src={img} alt="gmail" />
                    <div className="text">{name}</div>
                </div>
            </Link>
        </div>
    }
    return (
        <div className="nav-sidebar-root">
            <div className="menu"><Menu sx={{ cursor: "pointer" }} onClick={toggleDrawer(true)}></Menu></div>
            <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
                <Box sx={{ height: 1 }}
                >

                    {isLoggedIn && <div className="logged-user">

                        <div className={"profile-pic-wrp " + (profileCompleted > 80 ? 'good' : profileCompleted > 50 ? 'medium' : 'bad')}>
                            <CircularProgress variant="determinate" value={profileCompleted} />
                            <Avatar alt="Remy Sharp" src={profile} />
                            <Typography variant="caption" component="div" color="text.secondary">{`${Math.round(profileCompleted)}%`}</Typography>
                        </div>
                        <div className="user-wrp">
                            <div className="username">{user?.name}</div>
                            <div className="email">{user?.email}</div>
                            <Link reloadDocument={true} href={'/setting/personal-info'}>Edit Profile</Link>
                        </div>
                    </div>}
                    <div className="nav-sidebar-wrp" style={{marginTop: (!isLoggedIn ? '20px' : '0')}}>
                        <Box sx={{ mb: 2 }}>
                            <CustomAccordion accordians={toList(Object.keys(options), undefined, (item, i) => {
                                return {
                                    summary: <div className='accordian-summary'>
                                        <ListItemButton>
                                            {options[item]?.icon && <ListItemIcon>{options[item].icon}</ListItemIcon>}
                                            {options[item].options ? <ListItemText sx={{ fontSize: "14px" }} primary={options[item].name} /> :
                                                <div className="options">
                                                    <Link reloadDocument={true} href={options[item].to}>{options[item].name}</Link>
                                                    {options[item]?.tip && <div className="tip">{options[item]?.tip}</div>}
                                                    {options[item]?.bottomTip && <div className="bottomTip">{options[item]?.bottomTip}</div>}
                                                </div>}
                                        </ListItemButton>
                                    </div>,
                                    expand: options[item].options?.length,
                                    details: options[item].options ? <div className='accordian-details'>
                                        {options[item].options?.map((link, i) =>
                                            <Link reloadDocument={true} key={"option-" + i} href={link.to}><div className="option-wrp">
                                                {link.name}
                                                <div className="sub-title">{link?.subTitle}</div>
                                            </div></Link>
                                        )}
                                    </div> : undefined
                                }
                            })}></CustomAccordion>
                        </Box>
                    </div>

                    <div className="login-signup-wrp">
                        {!isLoggedIn &&
                            <>
                                {toLoginBtn(Email, 'Login With Email', '/login')}
                                {toLoginBtn(Gmail, 'Login With Gmail', '/login')}
                                <div className="divider">
                                    <div className="line"></div>
                                    <div className="Or">Or</div>
                                    <div className="line"></div>
                                </div>
                                <Link className="login" href='/signup'><CustomButton name='Sign Up' ></CustomButton></Link>
                            </>}
                        {isLoggedIn &&
                            <div className="logout"><CustomButton name='Sign Out' icon={<img src={Logout} alt='signout' />} onClick={(e) => logout(e)} ></CustomButton></div>}
                    </div>
                </Box>
            </Drawer>
        </div>
    );
}

export default HamburgerMenu;